import {
  Component,
  Inject,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormControl } from '@angular/forms';
import { UploadPhotoDetails } from '@aid/shared/types/classes/upload-photo-details.class';
import { Subject } from 'rxjs';

@Component({
  selector: 'aid-upload-photo-dialog',
  template: `
    <aid-dialog [title]="data.title" [closeButton]="false">
      <div
        class="container aid-layout-column aid-layout-align-space-between-center"
      >
        <!-- UploadPhotoService always sets these; fallbacks mirror aid-upload-photo. -->
        <aid-upload-photo
          [control]="control"
          [willCropPhoto]="true"
          [details]="data.details ?? ''"
          [acceptedFiles]="data.acceptedFile"
          [aspectRatio]="data.aspectRatio ?? 1"
          [roundCropper]="data.roundCropper ?? false"
          [horizontalSize]="data.horizontalResize ?? 0"
          [verticalSize]="data.verticalResize ?? 0"
        ></aid-upload-photo>

        <div class="full-width aid-layout-row aid-layout-align-end-center">
          <aid-form-actions
            [buttonLeft]="'cancel'"
            [buttonRight]="'upload'"
            (clickRight)="onSave()"
            (clickLeft)="onCancel()"
          ></aid-form-actions>
        </div>
      </div>
    </aid-dialog>
  `,
  styleUrls: ['./upload-photo-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UploadPhotoDialogComponent implements OnInit, OnDestroy {
  control: UntypedFormControl = new UntypedFormControl();

  private ngUnsubscribe = new Subject<void>();
  constructor(
    public dialogRef: MatDialogRef<UploadPhotoDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: UploadPhotoDetails
  ) {}

  ngOnInit() {}

  onCancel() {
    this.dialogRef.close();
  }
  onSave() {
    this.dialogRef.close(this.control.value);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
